import { VEHICLES_DELETE_STR } from "common/sf_strings";
import { MODE } from "helpers/sf_constants";
import { optionsGarageType, optionsPrimaryUse, optionsVehicleOwnership } from "helpers/sf_lead_constants";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { updateLeadVehicle, addLeadVehicle, deleteLeadVehicle } from "store/leads/lead_vehicles_actions";
import DeleteModal from "../DeleteModal";
import AddVehicleModal from "../Modals/AddVehicleModal";
import LeadEditDropdown from "./LeadEditDropdown";
import LeadEditDropdownForNumberFields from "./LeadEditDropdownForNumberFields";
import { getPrimaryTextClass } from "helpers/sf_utils";
import { addProspectVehicle, deleteProspectVehicle, updateProspectVehicle } from "store/prospects/prospects_vehicles_actions";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { useContext } from "react";

const LeadVehicles = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [lead_data, setLeadData] = useState({})
    const { lead_id } = useParams();
    const { leads } = useSelector(state => ({
        leads: state.Leads.leads,
    }));
    const dispatch = useDispatch();
    const [vehicleModalSatate, setVehicleModalSatate] = useState({ active: false });
    const [vehicleDeleteModal, setVehicleDeleteModal] = useState({ active: false, vehicle: {} })

    //Create a useeffect and get lead data from redux store from lead_id from useParams
    let leadVehicleUpdater = updateLeadVehicle
    let leadVehicleAdder = addLeadVehicle
    let leadVehicleDeleter = deleteLeadVehicle
    if (props?.is_prospect) {
        leadVehicleUpdater = updateProspectVehicle;
        leadVehicleAdder = addProspectVehicle
        leadVehicleDeleter = deleteProspectVehicle
    }
    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);

        }
    }, [props?.lead_data])

    const handleLaunchVehicleModal = (value) => {
        setVehicleModalSatate({ active: value });
    }

    const onClickSaveDriver = (mode, values) => {

        if (mode === MODE.EDIT) {
            dispatch(leadVehicleUpdater({ lead_vehicle: values }));
        } else {
            dispatch(leadVehicleAdder(values));
        }
        handleLaunchVehicleModal(false)
    }

    // For Delete Vehicle Modal
    const launchDeleteViolationModal = (vehicle) => {
        setVehicleDeleteModal({ action: true, vehicle: vehicle });
    };

    const onClickVehicleDeleteModal = (payload) => {
        dispatch(leadVehicleDeleter({ id: payload?.vehicle?.id }));
        setVehicleDeleteModal({ action: false, vehicle: {} });
    };

    return (
        <React.Fragment>
            {
                vehicleModalSatate && <AddVehicleModal
                    title={"Vehicle"}
                    leadApplicants={lead_data?.lead_applicants || null}
                    show={vehicleModalSatate}
                    onClickSaveDriver={onClickSaveDriver}
                    onCloseClick={() => handleLaunchVehicleModal(false)}
                />
            }
            <DeleteModal
                deleteModalState={vehicleDeleteModal}
                onDeleteClick={onClickVehicleDeleteModal}
                textMessage={VEHICLES_DELETE_STR}
                onCloseClick={() => setVehicleDeleteModal({ action: false, vehicle: {} })}
                cancelButton
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_vehicles?.map((vehicle, idx) =>
                                (
                                    <tbody id='primary_vehicles'>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-end pt-1 my-2">
                                                    <i className={`me-2 bx fs-24 bx-car ${getPrimaryTextClass()}`} />
                                                    <div className="me-2 fs-15 font-weight-semibold">
                                                        Vehicle #{idx + 1}
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => setVehicleModalSatate({ active: true, values: vehicle, mode: MODE.EDIT })}>Edit</a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly &&
                                                    <Col className={` ${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex align-items-end ${getPrimaryTextClass()}`}
                                                                onClick={() => launchDeleteViolationModal(vehicle)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Year
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            title='Year'
                                                            field={vehicle?.year}
                                                            noThousandSeparator={true}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.year = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Vehicle Usage
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsPrimaryUse}
                                                            title='Vehicle Usage'
                                                            field={vehicle?.primary_use}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.primary_use = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Garage
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsGarageType}
                                                            title='Garage'
                                                            field={vehicle?.garage_type}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.garage_type = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Make
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Make'
                                                            field={vehicle?.make}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.make = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Sub Model
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Sub Model'
                                                            field={vehicle?.sub_model}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.sub_model = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Miles Per Year
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdownForNumberFields
                                                            title='Miles Per Year'
                                                            field={vehicle?.annual_mileage}
                                                            commaFormatter={true}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.annual_mileage = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Model
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Model'
                                                            field={vehicle?.model}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.model = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Ownership
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsVehicleOwnership}
                                                            title='Ownership'
                                                            field={vehicle?.ownership_status}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.ownership_status = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        VIN
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='VIN'
                                                            field={vehicle?.vin}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = vehicle?.id
                                                                data.vin = value
                                                                dispatch(leadVehicleUpdater({ lead_vehicle: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        <div className="text-sfblue font-weight-semibold mt-4">
                            {!isReadOnly && <a onClick={() => handleLaunchVehicleModal(true)}>+ Add Vehicle</a>}
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadVehicles